import React, { useState } from 'react';
import { greetingForNow, WelcomePrompt } from './maestroWelcomePrompts';

interface MaestroWelcomeProps {
  firstName?: string;
  email?: string;
  primary: WelcomePrompt[];
  more: WelcomePrompt[];
  onSelect: (text: string) => void;
}

const SparkIcon: React.FC<{ kind?: WelcomePrompt['icon'] }> = ({ kind }) => {
  const color =
    kind === 'alert' ? '#d4380d' : kind === 'fleet' ? '#1664FF' : kind === 'sync' ? '#08979c' : '#7c5cff';
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        d="M8 1.2l1.15 3.55L12.8 6 9.15 7.25 8 10.8 6.85 7.25 3.2 6l3.45-1.25L8 1.2z"
        fill={color}
      />
      <path
        d="M12.4 9.4l.55 1.7 1.7.55-1.7.55-.55 1.7-.55-1.7-1.7-.55 1.7-.55.55-1.7z"
        fill={color}
        opacity="0.7"
      />
    </svg>
  );
};

const MaestroWelcome: React.FC<MaestroWelcomeProps> = ({
  firstName,
  email,
  primary,
  more,
  onSelect,
}) => {
  const [showMore, setShowMore] = useState(false);
  const { hello, prompt } = greetingForNow(firstName, email);

  return (
    <div className="maestro-welcome">
      <div className="maestro-welcome-copy">
        <h2>
          {hello}
          <br />
          {prompt}
        </h2>
      </div>
      <div className="maestro-welcome-prompts">
        {primary.map((item) => (
          <button
            key={item.text}
            type="button"
            className="maestro-welcome-prompt"
            onClick={() => onSelect(item.text)}
          >
            <span className="maestro-welcome-spark">
              <SparkIcon kind={item.icon} />
            </span>
            <span>{item.text}</span>
          </button>
        ))}
      </div>
      {more.length > 0 && (
        <>
          <button
            type="button"
            className="maestro-welcome-more"
            onClick={() => setShowMore((v) => !v)}
          >
            {showMore ? 'Fewer suggestions' : 'More suggestions'}
          </button>
          {showMore && (
            <div className="maestro-welcome-prompts is-more">
              {more.map((item) => (
                <button
                  key={item.text}
                  type="button"
                  className="maestro-welcome-prompt"
                  onClick={() => onSelect(item.text)}
                >
                  <span className="maestro-welcome-spark">
                    <SparkIcon kind={item.icon || 'spark'} />
                  </span>
                  <span>{item.text}</span>
                </button>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MaestroWelcome;
